import { useLocation, useParams } from "react-router-dom";
import SurveyLayout from "../../components/SurveyLayout/SurveyLayout";
import SurveysThanksUI from "./components/SurveysThanksUI";


const Main = () => {
  const { id } = useParams();
  const { pathname } = useLocation();

  return (
    <SurveyLayout pathname={pathname} id={id}>
      <SurveysThanksUI />
    </SurveyLayout>
  );
};

export default Main;
